import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M3.978 19.535a1 1 0 0 1 0-1.414L6.1 16a1 1 0 0 1 1.414 0l2.828 2.828-.706-.707a1 1 0 0 1 1.414 0l7.07-7.071a1 1 0 0 1 0-1.414l.708.707-2.829-2.829A1 1 0 0 1 16 6.1l2.122-2.121a1 1 0 0 1 1.414 0l2.12 2.121a1 1 0 0 1 1.414 0l2.83 2.83a1 1 0 0 1 0 1.414l2.121 2.121a1 1 0 0 1 0 1.414L25.9 16a1 1 0 0 1-1.414 0l-2.829-2.829.707.708a1 1 0 0 1-1.414 0l-7.071 7.07a1 1 0 0 1 0 1.415l-.707-.707L16 24.485a1 1 0 0 1 0 1.414l-2.121 2.122a1 1 0 0 1-1.414 0l-2.122-2.122a1 1 0 0 1-1.414 0L6.1 23.071a1 1 0 0 1 0-1.414l-2.122-2.122z" stroke="none"></path>';
export var WeightSVG = function WeightSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
WeightSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(WeightSVG);